function SvgComponent(props: any) {
    return (
      <svg
        width={164}
        height={96}
        viewBox="0 0 164 96"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M106.137 86.5c0 5.247-4.254 9.5-9.5 9.5h-30a9.5 9.5 0 010-19h.24a9.778 9.778 0 01-5-8.535c0-5.402 4.378-9.78 9.78-9.78h-34.52c-5.402 0-9.781-4.38-9.781-9.781 0-5.402 4.379-9.781 9.78-9.781h37.965c-5.398-.005-9.772-4.382-9.772-9.781 0-5.402 4.379-9.78 9.78-9.78H26.781c-5.402 0-9.781-4.38-9.781-9.782C17 4.38 21.379 0 26.78 0h78.247c5.402 0 9.781 4.379 9.781 9.78 0 5.402-4.379 9.781-9.781 9.781h27.617c5.401 0 9.78 4.38 9.78 9.781 0 5.402-4.379 9.78-9.78 9.78h-13.8c5.398.005 9.772 4.383 9.772 9.782 0 5.401-4.379 9.78-9.781 9.78h34.521c5.402 0 9.781 4.38 9.781 9.781 0 5.402-4.379 9.781-9.781 9.781h-52.012a9.497 9.497 0 014.793 8.254z"
          fill="#EDFFF5"
        />
        <circle cx={134} cy={6} r={2} fill="#D9D9D9" />
        <circle cx={43} cy={73} r={2} fill="#D9D9D9" />
        <path
          d="M151.703 47.854l-.203-.281-.203.28-2.165 3-.286.397h5.308l-.286-.396-2.165-3zM3.717 12.875L3.5 12.5l-.217.375-2.165 3.75L.902 17h5.196l-.216-.375-2.165-3.75z"
          stroke="#D9D9D9"
          strokeWidth={0.5}
        />
        <path
          d="M107 48v-2.5a2.5 2.5 0 00-2.5-2.5h-25a2.5 2.5 0 00-2.5 2.5v15a2.5 2.5 0 002.5 2.5h25a2.501 2.501 0 002.5-2.5V58m0-10H97a5 5 0 100 10h10m0-10a5.002 5.002 0 013.536 8.535A5.002 5.002 0 01107 58M84.5 43v-7.5a7.5 7.5 0 0115 0V43m6.25 10h2.5m-7.5 0h2.5m-7.5 0h2.5"
          stroke="#27AE60"
          strokeWidth={2}
        />
        <circle cx={79} cy={60} r={12} fill="#EDFFF5" />
        <path
          d="M86.071 52.929A9.935 9.935 0 0079 50a9.935 9.935 0 00-7.071 2.929A9.935 9.935 0 0069 60a9.935 9.935 0 002.929 7.071A9.935 9.935 0 0079 70a9.935 9.935 0 007.071-2.929A9.935 9.935 0 0089 60a9.935 9.935 0 00-2.929-7.071zm-2.293 4.691l-5.589 5.589a.584.584 0 01-.828 0l-3.139-3.139a.586.586 0 11.83-.828l2.723 2.724 5.174-5.175a.586.586 0 01.829.829z"
          fill="#27AE60"
        />
      </svg>
    )
  }
  
  export default SvgComponent